import { render, staticRenderFns } from "./OrderComposition.vue?vue&type=template&id=7c5e8395&scoped=true&"
import script from "./OrderComposition.vue?vue&type=script&lang=js&"
export * from "./OrderComposition.vue?vue&type=script&lang=js&"
import style0 from "./OrderComposition.vue?vue&type=style&index=0&id=7c5e8395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e8395",
  null
  
)

export default component.exports